import PageHero from "@/components/PageHero";
import { useLanguage } from "@/i18n/LanguageContext";

const C = {
  ar: {
    eyebrow: "الفريق",
    title: "فريق SAS",
    lead: "يقود المبادرة فريق تطوّعي متكامل يعمل بروح تشاركية لتخطيط البرامج، تطوير المحتوى، تحليل الأثر، والتنسيق مع الجامعات والمجتمع المحلي.",
    members: [
      { name: "محمد نور خيرو", role: "المؤسّس والمنسّق العام", scope: "مسؤول عن التخطيط والشراكات والرؤية العامة." },
      { name: "عماد الدين المصري", role: "المستشار التقني", scope: "مسؤول عن تطوير المحتوى التقني والتدريب المتقدّم." },
      { name: "عامر العلي", role: "مسؤول التفاعل الطلابي", scope: "التنسيق مع الكليات وإدارة الفعاليات الميدانية." },
      { name: "أحمد جاويش حجة", role: "محلل البيانات", scope: "تحليل الاستبيانات وقياس الأثر وتقييم الأداء." },
      { name: "محمد صالح أبي زيد", role: "الدعم المحلي", scope: "التواصل مع الجهات وتسهيل التنفيذ داخل الجامعات." },
    ],
  },
  en: {
    eyebrow: "The team",
    title: "The SAS team",
    lead: "SAS is led by an integrated volunteer team that works collaboratively on programme planning, content development, impact analysis, and coordination with universities and the community.",
    members: [
      { name: "Mohammad Nour Khayrou", role: "Founder & General Coordinator", scope: "Responsible for planning, partnerships, and overall vision." },
      { name: "Imad Al-Deen Al-Masri", role: "Technical Advisor", scope: "Leads technical content development and advanced training." },
      { name: "Amer Al-Ali", role: "Student Engagement Lead", scope: "Coordinates with faculties and manages on-the-ground events." },
      { name: "Ahmad Jawish Hajja", role: "Data Analyst", scope: "Analyses surveys, measures impact, and evaluates performance." },
      { name: "Mohammad Saleh Abi Zaid", role: "Local Support", scope: "Liaises with partners and facilitates execution inside universities." },
    ],
  },
};

function initials(name) {
  const parts = name.trim().split(/\s+/);
  return (parts[0]?.[0] || "") + (parts[1]?.[0] || "");
}

export default function Team() {
  const { lang } = useLanguage();
  const c = C[lang];

  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
      <section className="sas-section" data-testid="team-list">
        <div className="sas-container">
          <div className="sas-grid-3">
            {c.members.map((m, i) => (
              <article key={m.name} className="sas-card" data-testid={`team-card-${i}`}>
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center text-[color:var(--sas-accent)] font-semibold"
                  style={{ background: "var(--sas-accent-soft)" }}
                  aria-hidden
                >
                  {initials(m.name)}
                </div>
                <h3 className="sas-h3 mt-5">{m.name}</h3>
                <div className="text-sm font-medium text-[color:var(--sas-accent)] mt-1">{m.role}</div>
                <p className="sas-body mt-3 text-[15px]">{m.scope}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
